import { render } from "./promotioncode.vue?vue&type=template&id=073e95a1"
import script from "./promotioncode.vue?vue&type=script&lang=js"
export * from "./promotioncode.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__